export const isDev = () => {
  return import.meta.env.VITE_ENVIRONMENT === 'lab';
};

export const isStaging = () => {
  return import.meta.env.VITE_ENVIRONMENT === 'qa';
};

export const isProd = () => {
  return import.meta.env.VITE_ENVIRONMENT === 'prod';
};

export const isTestCookiePresent = () => {
  return document.cookie.indexOf('obi_tech_test=1') > -1;
};
